import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ClipboardJS from "clipboard";
import Modal from "../components/Modal";
import useControl from "../hooks/useControl";
import "./styles/scss/Personal.scss";
import {
	Request,
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	dateFormate,
	logOut,
	sysMsg,
	openBrowser,
	checkLogin,
	specialNavigate,
} from "../common";
import gameNone from "../styles/scss/img/common/game-none.png";
import startIcon from "./styles/scss/img/personal/start-icon.png";
import stopIcon from "./styles/scss/img/personal/stop-icon.png";
import orderNone from "./styles/scss/img/personal/order-none.png";
import yebao from "./styles/scss/img/personal/yebao.png";
import ak from "./styles/scss/img/personal/ak.png";
import memberImg from "./styles/scss/img/personal/member-img.png";

export default function App() {
	let { nav } = useParams();
	nav = nav / 1;
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);
	const [orderNav, setOrderNav] = useState(0);
	const [orderList, setOrderList] = useState([]);
	const { readyStart, stopGame, onProcessGame } = useControl();

	const memberTime = _state.userInfo?.totalMinutes;

	const isOnlineGame = ({ productName }) => {
		return (
			onProcessGame?.playParam?.[1] === productName && onProcessGame?.isOnline
		);
	};

	const navRightClass =
		nav === 0
			? "game"
			: nav === 1 || nav === 2
			? "order"
			: nav === 3
			? "jsqorder"
			: "";

	const contentClass = `content${
		nav === 0
			? " game"
			: nav === 1 || nav === 2
			? " order"
			: nav === 3
			? " jsqorder"
			: ""
	}`;

	useEffect(() => {
		let req = null;
		if (nav === 0) {
			req = new Request({
				url: "/api/user/v1/game_records",
				source: 2,
				headers: {
					token: _state.token,
				},
				data: {
					page: 1,
					page_size: 100,
				},
			});
		} else if (nav === 1) {
			req = new Request({
				url: "/api/user/v1/product",
				source: 2,
				headers: {
					token: _state.token,
				},
				data: {
					page: 1,
					page_size: 100,
					status: orderNav,
					type: 0,
				},
			});
		} else {
			req = new Request({
				url: "/api/user/v1/product",
				source: 2,
				headers: {
					token: _state.token,
				},
				data: {
					page: 1,
					page_size: 100,
					status: orderNav,
					type: nav,
				},
			});
		}

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.base.code === "200" && res.data) {
					if (nav === 1) {
						setOrderList(
							res.data.filter((ele) => ele.type === 1 || ele.type === 4)
						);
					} else {
						setOrderList(res.data);
					}
				} else if (res.base.code === "403" && _state.tokenProcess !== 1) {
					//403且token认证空闲
					setOrderList([]);
					logOut(_dispatch, true);
				} else {
					throw new Error("error");
				}
			} catch (error) {
				sysMsg({
					msg: "获取订单列表失败，请刷新",
				});
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [nav, orderNav, _state.token, _state.tokenProcess, _dispatch]);

	const defaultConfig = () => {
		setOrderList([]); //处理接口延迟列表显示错误问题
	};

	return (
		<div className="main">
			<div className="personal">
				<div className="nav">
					<div>
						{["我的游戏", "共享游戏订单", "独享游戏订单", "加速器订单"].map(
							(ele, index) => {
								return (
									<button
										type="button"
										key={index}
										className={nav === index ? "active" : ""}
										onClick={() => {
											if (index !== nav) {
												defaultConfig();
											}

											specialNavigate(
												`/Personal/${index}`,
												_state.token,
												navigate,
												false,
												{}
											);
										}}
									>
										{ele}
									</button>
								);
							}
						)}
					</div>
					<div className={navRightClass}>
						{nav === 0 ? (
							<button
								type="button"
								onClick={() => {
									specialNavigate(
										"/MemberGame",
										_state.token,
										navigate,
										false,
										{}
									);
								}}
							>
								查看所有大会员游戏&gt;
							</button>
						) : (
							(nav === 1
								? ["全部", "已完成", "补货中", "已退款", "维权中"]
								: nav === 2
								? ["全部", "已完成", "补货中", "已退款"]
								: []
							).map((ele, index) => {
								return (
									<React.Fragment key={index}>
										<button
											type="button"
											className={orderNav === index ? "active" : ""}
											onClick={() => {
												if (index !== orderNav) {
													defaultConfig();
												}

												setOrderNav(index);
											}}
										>
											{ele}
										</button>
									</React.Fragment>
								);
							})
						)}
					</div>
				</div>

				<div className={contentClass}>
					{nav === 0 ? (
						orderList.length ? (
							orderList.map((ele, index) => {
								return (
									<div className="list-item" key={index}>
										<div
											className="left"
											style={{
												backgroundImage: `url(${ele.gameImg})`,
											}}
										>
											<div className="shadow">
												{isOnlineGame(ele) ? (
													<>
														<button
															type="button"
															className="stop-btn"
															onClick={async () => {
																try {
																	await stopGame();
																} catch (error) {
																	sysMsg({
																		msg: "停止游戏失败",
																	});
																}
															}}
														>
															<img src={stopIcon} alt="icon" />
															停止游戏
														</button>
													</>
												) : (
													<>
														{ele.type === 1 ? (
															ele.isDeleted === 0 && (
																<button
																	type="button"
																	className="start-btn"
																	onClick={() => {
																		readyStart(ele);
																	}}
																>
																	<img src={startIcon} alt="icon" />
																	启动游戏
																</button>
															)
														) : memberTime > 0 ? (
															<button
																type="button"
																className="start-btn"
																onClick={() => {
																	readyStart({
																		productId: ele.productId,
																		isMemberPlay: true,
																	});
																}}
															>
																<img src={startIcon} alt="icon" />
																启动游戏
															</button>
														) : (
															<button
																type="button"
																className="member-pay-btn"
																onClick={() => {
																	checkLogin(_state, _dispatch, () => {
																		_dispatch(
																			creator("setMemberPayIsShow", true)
																		);
																	});
																}}
															>
																开通
															</button>
														)}
														<div>
															累积游戏{parseInt(ele.useMinutes / 60)}小时
														</div>
													</>
												)}
											</div>
										</div>
										<div className="right">
											<div>{ele.productName}</div>
											<div>{ele.gameNameEn}</div>
											{ele.type === 1 ? (
												<div className="share">共享账号</div>
											) : (
												<div className={memberTime > 0 ? "free" : "outday"}>
													{memberTime > 0 ? "大会员免费使用" : "大会员已过期"}
												</div>
											)}
										</div>
									</div>
								);
							})
						) : (
							<div className="none">
								<img src={gameNone} alt="none" />
								<p>当前暂无任何游戏...</p>
							</div>
						)
					) : nav === 1 || nav === 2 ? (
						orderList.length ? (
							orderList.map((ele, index) => {
								return (
									<div className="list-item" key={index}>
										<div>
											<div
												style={{
													backgroundImage: `url(${
														ele.type === 1
															? ele.gameImg
															: ele.type === 2
															? `https://cdn-wjyz.wanjiayizhan.com${encodeURI(
																	ele.gameImg
															  )}`
															: memberImg
													})`,
												}}
											>
												<div
													className={`flag${
														ele.status === 1
															? " done"
															: ele.status === 2
															? " wait"
															: ele.status === 3
															? " back"
															: " appeal"
													}`}
												>
													{ele.status === 1
														? "已完成"
														: ele.status === 2
														? "补货中"
														: ele.status === 3
														? "已退款"
														: "维权中"}
												</div>
											</div>
											<div>
												<div>{ele.productName}</div>
												<div>支付金额：{ele.amount}元</div>
												<div>订单号：{ele.orderOutSn}</div>
											</div>
											<div>
												时间：
												{dateFormate(
													"yyyy-MM-DD HH:mm:ss",
													new Date(ele.createdAt)
												)}
											</div>
										</div>

										<div>
											{nav === 1 ? (
												<>
													<button
														type="button"
														className="kf-btn"
														onClick={() => {
															openBrowser(
																"http://wpa.qq.com/msgrd?v=3&uin=2796588134&site=qq&menu=yes"
															);
														}}
													>
														联系客服
													</button>
													{window.mbQuery &&
														ele.type === 1 &&
														ele.status === 1 &&
														(isOnlineGame(ele) ? (
															<button
																type="button"
																className="stop-btn"
																onClick={async () => {
																	try {
																		await stopGame();
																	} catch (error) {
																		sysMsg({
																			msg: "停止游戏失败",
																		});
																	}
																}}
															>
																停止游戏
															</button>
														) : (
															<button
																type="button"
																className="start-btn"
																onClick={() => {
																	readyStart(ele);
																}}
															>
																开始游戏
															</button>
														))}
												</>
											) : ele.status === 1 ? (
												<>
													<button
														type="button"
														className="kf-btn"
														onClick={() => {
															openBrowser(
																"http://wpa.qq.com/msgrd?v=3&uin=2796588134&site=qq&menu=yes"
															);
														}}
													>
														联系客服
													</button>
													<button
														type="button"
														className="get-account-btn"
														onClick={() => {
															let data = ele.cdk;
															const isAccount = data.includes("steamAccount");
															let copyText = data;

															try {
																const dataArr = data.split("&&&");

																data = [];

																for (const element of dataArr) {
																	if (isAccount) {
																		const datastr = JSON.parse(element);

																		data.push([
																			`邮箱地址：${datastr?.mailAddress}`,
																			`邮箱账号：${datastr?.mailAccount}`,
																			`邮箱密码：${datastr?.mailPassword}`,
																			`游戏账号：${datastr?.steamAccount}`,
																			`游戏密码：${datastr?.steamPassword}`,
																		]);
																	} else {
																		data.push(element);
																	}
																}

																copyText = "";

																if (isAccount) {
																	for (const element of data) {
																		copyText += element.join("，");
																	}
																} else {
																	copyText = data.join("，");
																}
															} catch (error) {
																data = "加载卡密出错，请联系客服";
															}

															Modal.tips({
																contentHead: ele.productName,
																contentBody: (
																	<div
																		className="customer-scrollbar"
																		style={{
																			width: 340,
																			height: 110,
																		}}
																	>
																		{isAccount
																			? data.map((item, index) => {
																					return (
																						<>
																							<div
																								style={{
																									fontSize: 14,
																									color: "#fff",
																									marginTop: 12,
																									marginBottom: 5,
																								}}
																							>
																								卡密{index + 1}：
																							</div>
																							{item.map((ele, index) => {
																								return (
																									<div
																										key={index}
																										style={{
																											userSelect: "auto",
																											color: "#5DFE97",
																										}}
																									>
																										{ele}
																									</div>
																								);
																							})}
																						</>
																					);
																			  })
																			: data.map((ele, index) => {
																					return (
																						<div
																							key={index}
																							style={{
																								userSelect: "auto",
																								color: "#5DFE97",
																							}}
																						>
																							{ele}
																						</div>
																					);
																			  })}
																	</div>
																),
																onOk: (c) => {
																	const clipboard = new ClipboardJS(
																		".wjyz-cdk-copy"
																	);
																	clipboard.on("success", function (e) {
																		c();
																		clipboard.destroy?.();

																		sysMsg({
																			icon: "succ",
																			msg: "复制成功",
																		});
																	});
																},
																okText: (
																	<div
																		className="wjyz-cdk-copy"
																		data-clipboard-text={copyText}
																		style={{
																			height: "100%",
																			lineHeight: "38px",
																		}}
																	>
																		复制
																	</div>
																),
																cancelBtn: null,
															});
														}}
													>
														领取卡密
													</button>
												</>
											) : ele.status === 2 ? (
												<>
													<button
														type="button"
														className="kf-btn"
														onClick={() => {
															openBrowser(
																"http://wpa.qq.com/msgrd?v=3&uin=2796588134&site=qq&menu=yes"
															);
														}}
													>
														联系客服
													</button>
													<button type="button" className="wait-btn">
														等待发货
													</button>
												</>
											) : ele.status === 3 ? (
												<button type="button" className="back-btn">
													已退款
												</button>
											) : (
												<button type="button" className="appeal-btn">
													维权中
												</button>
											)}
										</div>
									</div>
								);
							})
						) : (
							<div className="none">
								<img src={orderNone} alt="none" />
								<p>当前暂无任何订单...</p>
							</div>
						)
					) : nav === 3 ? (
						orderList.length ? (
							orderList.map((ele, index) => {
								return (
									<div className="list-item" key={index}>
										<div>
											<div
												style={{
													backgroundImage: `url(${
														ele.jsqImg === "yebao" ? yebao : ak
													})`,
												}}
											></div>
											<div>
												<div>{ele.productName}</div>
												<div>支付金额：{ele.amount}元</div>
												<div>订单号：{ele.orderOutSn}</div>
											</div>
											<div>
												时间：
												{dateFormate(
													"yyyy-MM-DD HH:mm:ss",
													new Date(ele.createdAt)
												)}
											</div>
										</div>

										<div>
											<button
												type="button"
												className="kf-btn"
												onClick={() => {
													openBrowser(
														"http://wpa.qq.com/msgrd?v=3&uin=2796588134&site=qq&menu=yes"
													);
												}}
											>
												联系客服
											</button>
											<button
												type="button"
												className="download-btn"
												onClick={() => {
													openBrowser(
														ele.jsqImg === "yebao"
															? "https://www.yebaojiasu.com"
															: "https://www.akspeedy.com"
													);
												}}
											>
												下载加速器
											</button>
										</div>
									</div>
								);
							})
						) : (
							<div className="none">
								<img src={orderNone} alt="none" />
								<p>当前暂无任何订单...</p>
							</div>
						)
					) : (
						<></>
					)}
				</div>
			</div>
		</div>
	);
}
